import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import RegionWorkingDays from "@/models/Settings/Regions/RegionWorkingDays";

export default class Region extends BaseInstitutionEntity {
    name: string = '';
    default: boolean = false;;
    timezone: string = '';
    defaultCulture: string = '';
    availableCurrencies: string[] = [];
    defaultCurrency: string = '';
    workingDays: RegionWorkingDays = new RegionWorkingDays();
}